import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import AgendaGroup from 'modules/events/groups/AgendaGroup';
import AttendanceProofGroup from 'modules/events/groups/AttendanceProofGroup/AttendanceProofGroup';
import CventGroup from 'modules/events/groups/CventGroup';
import NavigationConfigGroup from 'modules/events/groups/NavigationConfigGroup/NavigationConfigGroup';
import OptionalInformationsGroup from 'modules/events/groups/OptionalInformationsGroup';
import ParticipantPhoneNumberGroup from 'modules/events/groups/ParticipantPhoneNumberGroup';
import PrimaryInformationsGroup from 'modules/events/groups/PrimaryInformationsGroup';
import RestrictedAccessGroup from 'modules/events/groups/RestricedAccessGroup/RestrictedAccessGroup';
import SessionInformationGroup from 'modules/events/groups/SessionInformationGroup';
import SpeakersGroup from 'modules/events/groups/SpeakersGroup';
import TimeSlotGroup from 'modules/events/groups/TimeSlotGroup';
import useDetailsStep from 'modules/events/routes/CreateHybridMeeting/Steps/DetailsStep/DetailsStep.hook';
import Box from 'yoda-ui/components/Box';

const DetailsStep: FC = () => {
  const flags = useFlags();

  useDetailsStep();
  return (
    <Box>
      <TimeSlotGroup />
      <SessionInformationGroup />
      <NavigationConfigGroup/>
      <AttendanceProofGroup/>
      <PrimaryInformationsGroup />
      {
        flags.eventsCweb368EnableCventSection
        && <CventGroup />
      }
      <SpeakersGroup />
      <OptionalInformationsGroup />
      <ParticipantPhoneNumberGroup />
      <AgendaGroup />
      <RestrictedAccessGroup />
    </Box>
  );
};

export default DetailsStep;
